<!-- TODO for v2.1 - This has to be merged with NotificationModal and should have option to be shown in this 'light' version. -->

<template>
  <ValidationObserver
    ref="sendTemplateForm"
    v-slot="{ valid }">
    <b-modal
      id="new-conversation-notification-send-modal"
      ref="notificationModal"
      class="static-modal"
      title-class="flex center-all"
      centered
      hide-header-close
      :static="true"
      size="xl"
      ok-title="Send"
      :no-fade="!visible"
      :ok-disabled="!valid"
      :lazy="true"
      @shown="onShow"
      @hidden="resetData"
      @ok="submit"
      @cancel="removeTempConversation" >
      <!-- Modal Title -->
      <template slot="modal-title">
        Start a conversation with {{ phone }}
      </template>

      <!-- CONSENT view -->
      <!-- Body -->
      <div
        v-if="!consent"
        class="consent-body-wrapper flex column">
        <span class="icon" />
        <h3>Permission to WhatsApp this contact</h3>
        <p>You didn’t chat with this contact on WhatsApp yet. Please confirm
          that you have their permission to message them on WhatsApp.
          Learn more about WhatsApp opt-in policies here.</p>
      </div>

      <!-- Footer -->
      <template
        v-if="!consent"
        #modal-footer="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          variant="secondary"
          @click="cancel()">
          I don’t have consent
        </b-button>
        <b-button
          variant="primary"
          class="flex"
          @click="confirmConsent">
          I have consent
        </b-button>
      </template>
      <!-- CONSENT view END-->

      <NoTemplate v-if="consent && !hasApprovedTemplateMessages"/>
      <!-- The event will be emitted and standard template modal will be shown instead of the below content. -->
      <!-- <template v-if="consent">
        No template message is shown if there are no templates to be shown.
        <NoTemplate v-if="!hasApprovedTemplateMessages"/>

        <div
          v-else
          class="notification-send-form" >
          <div
            v-show="hasApprovedTemplateMessages">
            <b-form-group>
              <label
                class="col-form-label pt-0">
                Template
              </label>
              <multiselect
                v-model="selectedTemplate"
                placeholder="Select Template"
                :options="templateKeywords"
                :preselect-first="true"
                :multiple="false"
                :searchable="false"
                :show-labels="false"
                :show-no-results="false"
                :allow-empty="false">
                <template
                  slot="singleLabel"
                  slot-scope="{ option }">
                  {{ option | removeUnderscore }}
                </template>
                <template
                  slot="option"
                  slot-scope="props">
                  {{ props.option | removeUnderscore }}
                </template>
              </multiselect>
            </b-form-group>

            <b-form-group>
              <div class="template-label-wrapper flex space-between">
                <label>Message</label>
                <multiselect
                  v-if="languages.length > 1"
                  v-model="selectedLanguage"
                  :class="{'hover': languageMultiselectHoverState}"
                  :options="languages"
                  placeholder="Select Language"
                  track-by="languageCode"
                  label="languageName"
                  :preselect-first="true"
                  :multiple="false"
                  :searchable="false"
                  :show-labels="false"
                  :show-no-results="false"
                  :allow-empty="false"
                  :max-height="300"
                  @mouseover.native="addHover"
                  @mouseout.native="removeHover" >
                  <template slot="beforeList">
                    <span class="lang-list-label">All languages</span>
                  </template>
                </multiselect>
              </div>
              <span
                id="popover-message"
                class="message box-shadow"
                v-html="message"/>
              <b-popover
                target="popover-message"
                triggers="hover"
                placement="top"
                custom-class="basic-popover">
                This can't be edited
              </b-popover>
            </b-form-group>

            <template v-if="selectedTemplateLanguageVersion">
              <b-form-group
                v-for="tag in selectedTemplateLanguageVersion.tags"
                :key="tag">
                <label>{{ tag }}</label>
                <ValidationProvider
                  :ref="tag"
                  v-slot="{ errors }"
                  :name="`Tag '${tag}'`"
                  rules="required">
                  <b-form-input
                    v-model="tagsToSend[tag]"
                    placeholder="Enter value" />
                  <div
                    v-if="errors[0]"
                    class="error flex flex-align-center">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </template>

            <template
              v-if="selectedTemplateLanguageVersion && selectedTemplateLanguageVersion.attachment">
              <b-form-group>
                <label
                  class="col-form-label p-0 m-0">
                  File Attachment
                </label>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Attachment"
                  rules="required">
                  <DropZone
                    ref="dropZone"
                    v-model="files"
                    :extensions="allowedTemplateMessageAttachments(selectedTemplateLanguageVersion.attachment)"
                    @dropped-in="fileDropped"/>
                  <div
                    v-if="errors[0]"
                    class="error flex flex-align-center">
                    <SBIcon
                      :icon="SBIconList.ERROR"
                      :color="SBColors.redPrimary"
                      :size="12" />
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </template>
          </div>
        </div>
      </template> -->
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

import { escapeHtml, whatsappFormatMessage } from '@/helpers/stringHelpers';
import getLanguageName from '@/helpers/getLanguageName';
import DropZone from '../../../common/DropZone';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import { allowedTemplateMessageAttachments } from '../../../../helpers/mediaHelpers';
import NoTemplate from '../partials/NoTemplate';
import randomString from '@/helpers/randomString';

export default {
  name: 'NewConversationNotificationModal',
  components: {
    Multiselect,
    DropZone,
    NoTemplate,
    SBIcon,
  },
  data() {
    return {
      consent: false,
      templates: null,
      branchId: null,
      files: [],
      phone: null,
      formData: new FormData(),
      languageMultiselectHoverState: false,
      languages: [],
      selectedLanguage: null,
      selectedTemplate: null,
      selectedTemplateObject: null,
      selectedTemplateLanguageVersion: null,
      tagsToSend: {},
      visible: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      apiError: 'notification/apiError',
      notificationTags: 'notification/notificationTags',
      notificationTagsLoaded: 'notification/notificationTagsLoaded',
      activeConversation: 'chat/activeConversation',
    }),
    /** Checks if there is at least one approved template message. */
    hasApprovedTemplateMessages() {
      return this.templates && this.templateKeywords.length;
    },
    /** Computes the message content from the tags data populated by user. */
    message() {
      let selectedTemplateMessage = this.selectedTemplateLanguageVersion ? escapeHtml(this.selectedTemplateLanguageVersion.text.trim()) : '';
      if (this.selectedTemplateLanguageVersion) {
        this.selectedTemplateLanguageVersion.tags.forEach((tag) => {
          if (this.tagsToSend[tag]) {
            selectedTemplateMessage = selectedTemplateMessage.replace(new RegExp(`\\{\\{${tag}\\}\\}`, 'g'), this.tagsToSend[tag]);
          }
        });
        selectedTemplateMessage = selectedTemplateMessage.replace(/{{(.*?)}}/g, '<span class="editor-tag ellipsis">$1</span>');
      }
      return selectedTemplateMessage;
    },
    /** Creates a list of approved template names to be populated on the templates multiselect. */
    templateKeywords() {
      const templateKeywords = [];
      this.templates.data.forEach((templateLang) => {
        if (templateLang.status === 'approved') {
          templateKeywords.push(templateLang.keyword);
        }
      });

      return templateKeywords;
    },
  },
  watch: {
    $route() {
      this.hide();
    },
    /** Sets the selected template object and resets the tags input on template change. */
    selectedTemplate() {
      this.resetTags();
      if (this.selectedTemplate) {
        this.selectedTemplateObject = this.templates.data.find(template => template.keyword === this.selectedTemplate.replace(/\s/g, '_'));
      }
    },
    /** Sets the available languages for the selected template. */
    selectedTemplateObject() {
      this.selectedLanguage = null;
      // TODO languages are handled differently and this needs to be refactored
      this.languages = this.selectedTemplateObject.map(templateVersion => ({
        languageName: getLanguageName(templateVersion.language, false),
        languageCode: templateVersion.language,
      }));
      // select language automatically if only one is available
      if (this.languages.length === 1) {
        [this.selectedLanguage] = this.languages;
      }
    },
    /** Resets tags on language change. */
    selectedLanguage() {
      this.resetTags();
      if (!this.selectedLanguage) {
        this.selectedTemplateLanguageVersion = null;
      } else {
        this.selectedTemplateLanguageVersion = this.selectedTemplateObject.find(
          template => template.language === this.selectedLanguage.languageCode,
        );
      }
    },
  },
  mounted() {
    this.$eventBus.$on('show-notification-modal', this.show);
  },
  beforeDestroy() {
    this.$eventBus.$off('show-notification-modal', this.show);
  },
  methods: {
    ...mapActions({
      sendTemplateMessage: 'notification/sendTemplateMessage',
      loadAvailableNotificationTags: 'notification/loadAvailableNotificationTags',
    }),
    allowedTemplateMessageAttachments,
    /** Handles file drop on the file input. */
    fileDropped(file) {
      if (file) {
        this.formData.set('file', file[0]);
      }
    },
    onShow() {
      this.visible = true;
    },
    onHide() {
      this.visible = false;
    },
    /** Resets the data on the template form. */
    resetData() {
      this.resetTags();
      this.selectedTemplate = null;
      this.phone = null;
      this.consent = false;
      this.$refs.sendTemplateForm.reset();
    },
    /** Resets tags. */
    resetTags() {
      this.tagsToSend = {};
      this.$refs.sendTemplateForm.reset();
    },
    /** Brings up the moda, fetches the templates and sets the recepient. */
    show(payload) {
      this.phone = payload.phone;
      this.templates = payload.templateMessageList;
      this.branchId = payload.businessId;
      this.$refs.notificationModal.show();
    },
    hide() {
      this.$refs.notificationModal.hide();
    },
    /** Submits new template message to thw user. */
    submit() {
      this.$refs.sendTemplateForm.validate();
      if (this.$refs.sendTemplateForm.flags.valid) {
        const sendData = {};
        Object.keys(this.tagsToSend).forEach((tag) => {
          sendData[tag] = this.tagsToSend[tag].replace(/!!!(.*?)!!!/g, '{{$1}}');
        });

        const tempSid = randomString();

        this.formData.set('number', this.phone);
        this.formData.set('keyword', this.selectedTemplate);
        this.formData.set('language', this.selectedLanguage.languageCode);
        this.formData.set('tags', JSON.stringify(sendData));
        this.formData.set('temp_sid', tempSid);
        const payload = {
          merchant_id: this.branchId,
          conversation_id: this.activeConversation.id,
          data: this.formData,
        };

        this.sendTemplateMessage(payload)
          .then(() => {
            this.$eventBus.$emit('sync-new-temp-conversation-id');
          })
          .catch((error) => {
            if (this.isNetworkError(error)) {
              this.$eventBus.$emit('pillmessage', 'Sending template message failed');
            }
          })
          .finally(() => {});

        const outboundMessageData = {
          sid: tempSid,
          body: whatsappFormatMessage(this.message), // TODO test this with template that has something bolded
          media_type: null,
          media_url: null,
          loaded: true,
          direction: 'template_message',
          status: 'sending',
          timestamp: this.$moment().unix(),
        };

        this.$eventBus.$emit('set-temp-message', outboundMessageData);
        this.$eventBus.$emit('change-new-temp-conversation-id', tempSid);
      }
    },
    /**
     * Checks if the cursor is above the multiselect select or tags section and only shows the hover state in that case.
     * It had to be done like that because setting the :hover on multiselect also trigers it if the cursor is above the list and that is not how we want it to be shown.
     *
     * @param event Mouse event
     */
    addHover(event) {
      event.path.some((element) => {
        this.languageMultiselectHoverState = element.className.indexOf('multiselect__select') >= 0 || element.className.indexOf('multiselect__tags') >= 0;
        return this.languageMultiselectHoverState || element.className.indexOf('multiselect') === -1;
      });
    },
    /**
     * Removes the hover state set by the addHover method.
     */
    removeHover() {
      this.languageMultiselectHoverState = false;
    },
    removeTempConversation() {
      // Do not remove on cancel
      // this.$eventBus.$emit('remove-new-temp-conversation');
    },
    confirmConsent() {
      this.consent = true;

      if (this.consent && this.hasApprovedTemplateMessages) {
        this.$emit('start-new-notification');
        this.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep #new-conversation-notification-send-modal {
  &.modal:not(.fit-width) .modal-dialog {
    width: 484px!important;
  }

  .consent-body-wrapper {
    padding: 20px;
    border-radius: 5px;
    border: solid 1px #e1e5eb;
    background-color: #f8fbff;

    .icon {
      height: 68px;
      background-image: url('~@/assets/img/SB-Images/wa-shield.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.05;
      text-align: center;
      color: $blackPrimary;
      margin: 15px 0 10px;
    }

    p {
      font-size: 14px;
      line-height: 1.2;
      text-align: center;
      color: $blackPrimary;
    }
  }

  .notification-send-form {
    .template-label-wrapper {
      z-index: 200;

      .multiselect {
        display: inline-block;
        max-width: fit-content;
        min-height: 16px !important;
        height: 16px;
        box-shadow: none;

        &:focus {
          box-shadow: unset !important;
        }

        .multiselect__select {
          padding: 0;
          height: 11px;
          width: 11px;
        }

        .multiselect__tags {
          padding: 0;
          min-height: 16px;
          height: 16px;
          border: none;

          .multiselect__single {
            font-size: 14px !important;
            line-height: 1.2 !important;
            color: $greyPrimary !important;
            padding-right: 18px !important;
          }
        }

        &.hover {
          .multiselect__single {
            color: $blackPrimary !important;
          }
          .multiselect__select {
            mask-image: url(~@/assets/img/SB-Icons/down-arrow.svg);
            mask-size: 11px auto !important;
            mask-repeat: no-repeat;
            mask-position: center;
            background-color: $blackPrimary;
          }
        }

        .multiselect__content-wrapper {
          width: 212px;
          right: 0;
          z-index: 101;
          margin-top: 4px;

          .multiselect__content {
            .lang-list-label {
              display: block !important;
              font-size: 12px !important;
              line-height: 1.4 !important;
              padding: 10px 0 3px 12px !important;
              color: $greyPrimary !important;
            }

            .multiselect__element {
              .multiselect__option {
                padding: 5px 12px !important;
                font-size: 14px !important;
                line-height: 1.2 !important;
                color: $blackPrimary !important;
              }
            }
          }
        }
      }
    }
  }
}

#new-conversation-notification-send-modal {
  .modal-title .icon {
    top: 2px;
    position: relative;
  }

  .modal-content {
    .modal-body {
      .spinner-wrapper {
        margin: 20px;
      }
    }
  }

  .check-consent {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .loader {
      position: unset !important;
      width: unset !important;
      margin: unset !important;
      margin-right: 5px !important;
    }
  }

  .contacts-spinner, .clear-contact {
    position: absolute;
    right: 10px;
    left: unset;
    top: 31px;
    width: fit-content;
    margin: 0;
    z-index: 100;
  }

  .clear-contact {
    padding: 8px;
    width: 30px;
    height: 30px;
    right: 6px;
    top: 23px;
  }

  .multiselect, input {
    height: 100%;
    border-radius: 5px;
    box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.1);
    &:focus {
      box-shadow: 0 0 0 3px #bfdeff !important;
    }
  }

  input {
    border: solid 1px #cfd8dc !important;
    background-color: #ffffff !important;
    padding: 7px 10px !important;
  }

  .message {
    display: block;
    border-radius: 5px;
    border: solid 1px #cfd8dc;
    background-color: #f8fafb;
    padding: 7px 10px;
    color: $blackPrimary;
    font-size: 14px;
    min-height: 32px;

    ::v-deep .editor-tag {
      position: relative;
      bottom: 1px;
      background-color: #fff;
      padding: 0 8px;
      border-radius: 30px;
      border: 1px solid $blackPrimary;
      font-weight: 500 !important;
      text-transform: capitalize;
      font-size: 12px !important;
    }
  }

  .send-btn {
    display: flex;
    align-items: center;
    margin-top: 22px;

    .loader {
      margin-right: 4px;
    }

    .message-sent {
      display: flex;

      img {
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 5px;
      }
    }
  }

  .main-error, .message-sent {
    margin-top: 22px !important;
  }

  .error {
    color: $redPrimary;
    margin-top: 5px;
    padding: 5px 11px 5px 6px;

    .sb-icon {
      margin-right: 6px;
    }
  }
}
</style>
